import type { CoordinatorDef, ServiceRequirement } from "./definitions";
import _ from "lodash";
import { LanguageTypeMapping } from "./definitions";

type QuotationCoordinatorProps = {
  coordinator: ServiceRequirement;
  index: number;
  excludedServiceUids: Set<string>;
  excludeSrv: (uid: string) => void;
  includeSrv: (uid: string) => void;
};

export function QuotationCoordinator({
  coordinator,
  index,
  excludedServiceUids,
  excludeSrv,
  includeSrv,
}: QuotationCoordinatorProps) {
  const preferences = coordinator.preferences as CoordinatorDef;
  const inclusions = preferences.inclusions;
  const exclusions = preferences.exclusions;

  return (
    <div
      key={`${index}-${coordinator.service_date}`}
      className="px-2 grid gap-1 bg-orange-100 rounded-md p-1"
    >
      <div className="inline-grid grid-cols-[1fr_max-content]">
        <span>{coordinator.notes}</span>
        <input
          type="checkbox"
          checked={!excludedServiceUids.has(coordinator.uid)}
          onChange={(e) => {
            if (e.target.checked) {
              includeSrv(coordinator.uid);
            } else {
              excludeSrv(coordinator.uid);
            }
          }}
        />
      </div>
      <div className="inline-grid grid-flow-col gap-1 auto-cols-max">
        {preferences.skills.length > 0 && (
          <span className="border border-orange-300 rounded-md p-1">
            <strong>Skills: </strong>
            {preferences.skills.map((s) => _.capitalize(s)).join(", ")}
          </span>
        )}
        {preferences.languages.length > 0 && (
          <span className="border border-orange-300 rounded-md p-1">
            <strong>Languages: </strong>
            {preferences.languages.map((s) => LanguageTypeMapping[s]).join(", ")}
          </span>
        )}
        {inclusions.length > 0 && (
          <span className="border border-orange-300 rounded-md p-1">
            <strong>Inclusions: </strong>
            {inclusions.map((s) => _.startCase(s)).join(", ")}
          </span>
        )}
        {exclusions.length > 0 && (
          <span className="border border-orange-300 rounded-md p-1">
            <strong>Exclusions: </strong>
            {exclusions.map((s) => _.startCase(s)).join(", ")}
          </span>
        )}
        {preferences.hours > 0 && (
          <span className="border border-orange-300 rounded-md p-1">
            <strong>Hours: </strong>
            {preferences.hours}
          </span>
        )}
      </div>
    </div>
  );
}
